/**
 * Keep Bitwarden and similar extensions off ephemeral OTP code fields.
 * Bitwarden's collector skips input[type=search] and [data-bwignore] (see bitwarden/clients collect-autofill-content).
 */
export function applyOtpCodeInputAttrs(input) {
  if (!input) return;
  input.type = 'search';
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('autocorrect', 'off');
  input.setAttribute('autocapitalize', 'none');
  input.setAttribute('spellcheck', 'false');
  input.setAttribute('aria-autocomplete', 'none');
  input.setAttribute('data-bwignore', 'true');
  input.setAttribute('data-1p-ignore', 'true');
  input.setAttribute('data-lpignore', 'true');
  input.setAttribute('data-form-type', 'other');
  input.removeAttribute('name');
  input.setAttribute('readonly', 'readonly');
  function unlock() {
    input.removeAttribute('readonly');
    input.removeEventListener('pointerdown', unlock);
    input.removeEventListener('keydown', unlockKey);
  }
  function unlockKey(e) {
    if (e.key === 'Tab' || e.key === 'Shift') return;
    unlock();
  }
  input.addEventListener('pointerdown', unlock);
  input.addEventListener('keydown', unlockKey);
}

/** Call when an OTP verify block becomes visible (dynamic login step). */
export function refreshOtpCodeInputs(root) {
  if (!root) return;
  root.querySelectorAll('[data-otp-token]').forEach(function (el) {
    applyOtpCodeInputAttrs(el);
  });
}
